import { createStore } from 'vuex'
import auth from './modules/auth'
import sched from './modules/sched'
import edit from './modules/edit'
import coredata from './modules/coredata'
import admin from './modules/admin'
const store = createStore({ modules: { auth, sched, edit, coredata, admin } })
export default store